import { noop } from 'lodash'
import { axios } from 'src/axios'
import { v4 } from 'uuid'

import consumer from './consumer'

interface SubscribeEvents {
  onConnect: (uuid: string) => void
  onData: (data: Record<string, unknown>) => void
}

export function generateFile (uuid: string, url: string) {
  const urlObject = new URL(url)

  urlObject.searchParams.append('uuid', uuid)
  axios.get(urlObject.toString()).catch(noop)
}

export function subscribe ({ onConnect, onData }: SubscribeEvents): void {
  const uuid = v4()
  const download = consumer.subscriptions.create(
    { channel: 'DownloadChannel', uuid },
    {
      connected () {
        onConnect(uuid)
      },
      received (data: Record<string, unknown>) {
        onData(data)
        consumer.disconnect()
        consumer.subscriptions.remove(download)
      },
    },
  )
}
